import D2C_Key from '../Key'

class D2C_KeySFTP extends D2C_Key {
  static objectType = 'keyType'
  static active = true
  static keyType = 'sftp'
  static fields = {
    ...D2C_Key.fields,
    default: {
      ...D2C_Key.fields.default,
      readonly: true,
    },
  }
}

export default D2C_KeySFTP
